import Collapse from './Collapse.jsx';

export default Collapse;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/ExtraFiltersCollapse/Collapse/index.js